import React, { useMemo } from 'react';
import { STTimeLineChartData } from '../../../../../../../redux/monitoring/api/monitoring-ui.model';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';

interface DigitalSeriesTableProps {
  digitalChannels: STTimeLineChartData;
}
function DigitalSeriesTable(props: DigitalSeriesTableProps) {
  const { digitalChannels } = props;
  const rows = useMemo(
    () => getDigitalRows(digitalChannels),
    [digitalChannels]
  );
  const columns = useMemo(
    () => [
      {
        field: 'timestampStart',
        headerName: 'Start Time',
        width: 200,
        renderCell: (params: any) => {
          return params.row.timestampStart
            ? moment.unix(params.row.timestampStart).format('L LTS')
            : '';
        },
      },
      {
        field: 'timestampEnd',
        headerName: 'End Time',
        width: 200,
        renderCell: (params: any) => {
          return params.row.timestampEnd
            ? moment.unix(params.row.timestampEnd).format('L LTS')
            : '';
        },
      },
      { field: 'value', headerName: 'Value', width: 120 },
      { field: 'deviceId', headerName: 'Device ID', width: 150 },
      { field: 'deviceName', headerName: 'Device Name', width: 180 },
      { field: 'eventId', headerName: 'Event ID', width: 150 },
      { field: 'eventName', headerName: 'Event Name', width: 180 },
      { field: 'controlunit', headerName: 'Control Unit ID', width: 150 },
      { field: 'controlunitName', headerName: 'Control Unit Name', width: 180 },
    ],
    [digitalChannels]
  );
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 25 },
        },
        sorting: { sortModel: [{ field: 'timestampStart', sort: 'desc' }] },
      }}
      disableRowSelectionOnClick
      pageSizeOptions={[10, 25, 50, 100, 200, 500, 1000]}
    />
  );
}

const getDigitalRows = (digitalChannels: STTimeLineChartData) => {
  return Object.values(digitalChannels).flatMap((channel) => {
    return channel.data.map((dataPoint) => {
      return {
        id: `${channel.deviceId}-${channel.controlUnitId}-${channel.eventId}-${dataPoint.originalStart}-${dataPoint.originalEnd}`,
        timestampStart: !dataPoint.fakeStart
          ? dataPoint.originalStart
          : undefined,
        timestampEnd: !dataPoint.fakeEnd ? dataPoint.originalEnd : undefined,
        value: dataPoint.value,
        deviceId: channel.deviceId,
        deviceName: channel.deviceName,
        eventId: channel.eventId,
        eventName: channel.textTranslation,
        controlunit: channel.controlUnitId,
        controlunitName: channel.controlUnitName,
      };
    });
  });
};

export default DigitalSeriesTable;
